// Copyright © 2021 Move Closer

import { RelatedType } from '../contracts'
import { SetDriver } from './set'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class DeduplicatedSetDriver extends SetDriver {
  /**
   * Key that stores RelatedType.
   * @protected
   */
  protected typeKey: RelatedType = RelatedType.DeduplicatedSet
}
